// src/components/AccountSettings.js

import React, { useState, useEffect } from 'react';
import supabase from '../supabase';
import UserContextViewer from './UserContextViewer'; // Make sure the path is correct

const AccountSettings = () => {
  const [currentUser, setCurrentUser] = useState(null); // Store the authenticated user

  // Fetch user profile and session on component mount
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
        if (sessionError) throw sessionError;

        const user = sessionData.session?.user;
        if (!user) throw new Error('No authenticated user found.');

        // Store the user in state for use in UserContextViewer
        setCurrentUser(user);
      } catch (error) {
        console.error('Error fetching profile:', error.message);
      }
    };

    fetchProfile();
  }, []);

  return (
    <div>
      {/* Render UserContextViewer if we have a user */}
      {currentUser && (
        <div className="mt-12">
          <UserContextViewer user={currentUser} />
        </div>
      )}
    </div>
  );
};

export default AccountSettings;
